// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"197e7c75","208":"03ce64d7","211":"e33fa75c","420":"7bc27eaf","592":"4b9a2445","796":"44a67fb5","804":"03590426"}[chunkId] + ".chunk.js";
};